import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import RankingSection from './components/RankingSection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="WebPage" data={{ name: '每日大赛 - 首页', url: 'https://dairise.github.io' }} />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <RankingSection />
        <ArticleSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}